import { getFormattedCurrency } from '@core/Utils/Intl/GetFormattedCurrency';
import { canShowDiscount } from '@core/Utils/Vehicle/CanShowDiscount';

import { ReducedPrice } from '../ReducedPrice/ReducedPrice';
import { type DefaultMapKeys, Typography } from '../Typography/Typography';
import type { TotalPriceProps } from './TotalPrice.entities';

import styles from './TotalPrice.module.css';

export const TotalPrice = ({
  pricing,
  variant = 'default',
  isScrolling,
  strings,
  hasCampaignDiscount,
  shallShowVatText = false,
  vatAdded = false,
}: TotalPriceProps) => {
  const showDiscount = canShowDiscount(pricing);

  if (showDiscount) {
    return (
      <ReducedPrice
        pricing={pricing}
        variant={variant}
        strings={strings}
        hasCampaignDiscount={hasCampaignDiscount}
        shallShowVatText={shallShowVatText}
        vatAdded={vatAdded}
      />
    );
  }

  const priceVariant = variant === ('carWithFinance' || 'podium') ? 'body1' : 'h3';
  const variantOnScroll = variant === ('carWithFinance' || 'podium') ? 'body1' : 'h5';

  return (
    <div className={styles.priceContainer} data-variant={variant}>
      <div className={styles.inlineVAT}>
        <Typography
          variant={isScrolling ? variantOnScroll : priceVariant}
          className={styles.totalPrice}
          Component="p"
          data-variant={variant}
        >
          {variant === 'carWithFinance' && ` ${strings.or} `}
          {getFormattedCurrency(pricing.price)}
        </Typography>
        {vatAdded && (
          <Typography Component="span" variant="caption2">
            {strings.vatIncluded}
          </Typography>
        )}
      </div>
      {shallShowVatText && (
        <Typography variant="caption2" Component="p" className={styles.vat}>
          {strings.vat}
        </Typography>
      )}
    </div>
  );
};
